var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-footer-text"},[_vm._v(" Copyright © 2022. All Rights Reserved. "+_vm._s(_vm.config.companyName)+" 版权所有 备案号："),_c('a',{attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank"}},[_vm._v("皖 ICP备2022012304号")])])}
var staticRenderFns = []

export { render, staticRenderFns }